import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=f573d1f0&scoped=true&"
import script from "./Scene.vue?vue&type=script&lang=ts&"
export * from "./Scene.vue?vue&type=script&lang=ts&"
import style0 from "./Scene.vue?vue&type=style&index=0&id=f573d1f0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f573d1f0",
  null
  
)

export default component.exports